import { Alert, Snackbar } from '@mui/material';
import * as React from 'react';


const SnackbarAlert = ({ message, open, vertical, horizontal, handleClose, severity, autoHideDuration }) => {


    return (
        <>
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={open}
                onClose={handleClose}
                key={vertical + horizontal}
                autoHideDuration={autoHideDuration ? autoHideDuration : 6000}
            >
                <Alert
                    //  onClose={handleClose}
                    severity={severity}
                    sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>
        </>
    );
}

export default SnackbarAlert;